import { styled } from 'styled-components';

export const ShareLinkContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    min-width: fit-content;
    width: fit-content;
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 8px;
`;
